module.exports = __webpack_public_path__ + "static/media/team.ebc42243.svg";